import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
// pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { RecoverPasswordRequest, RecoverPasswordConfirm } from './pages/RecoverPassword';
import NotFound from './pages/NotFound';
import TensaiRedirectAuth from './pages/TensaiRedirectAuth';
// services
import { AuthService } from './services';
import { connect } from 'react-redux';
import FirstPassword from './pages/FirstPassword';

function Routes({ needChangePassword, ...props }) {

  // services
  const authService = new AuthService();
  // anonymous components
  const DefaultRoute = (rprops) => (!authService.isAuthenticated() ? (
    <Route {...rprops} component={Login} />
  ) : (needChangePassword ? (<Route {...rprops} component={FirstPassword} />) : (<Route {...rprops} />)));     

  return (
    <Switch>
      <DefaultRoute exact path={'/'} component={Dashboard} {...props} />
      <DefaultRoute exact path={'/app'} component={Dashboard} {...props} />
      <Route exact path={'/recuperar-senha'} component={RecoverPasswordRequest} {...props} />
      <Route exact path={'/redefinir-senha'} component={FirstPassword} {...props} />
      <Route path={'/auth/tensai'} component={TensaiRedirectAuth} {...props} />
      <Route path={'/app/auth/tensai'} component={TensaiRedirectAuth} {...props} />
      <Route path={'/*'} component={NotFound} {...props} />
    </Switch>
  );
}

// [required]
const mapStateToProps = (state) => {
  console.log("@@@@@@@@@@@", state)
  return { needChangePassword: state.access.needChangePassword };
};

export default connect(mapStateToProps)(Routes);
